import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorMasterPostalCodeSearch = () => {
  const postalCodeSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-postal-code/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { postalCodeSearch }
}

export default InteractorMasterPostalCodeSearch
